
import { Component,Prop, BaseMixins,Watch } from '@/lib';
@Component({name:"query-footer"})
export default class QueryFooter extends BaseMixins{
    /*store table name 默认根据query解析*/
    @Prop({type:String, default:"table"}) resultFieldName:string;
    /*页数配置*/
    @Prop({type:Array, default:() => { return [10,20,30,40]}}) pageSizeOptions:Array<any>;
    /*查询dispatch type     module/menu/action*/
    @Prop({ type: String, required: true }) queryAction: string; 

    get commitType(){
        let arr = this.queryAction.split("/");
        return arr[0]+"/"+arr[1]+"/";
    }

    pageChange(page:number){
        let map = new Map();
        map.set("table", this.resultFieldName);
        map.set("currentPage", page);
        this.$store.commit(this.commitType + "setPageData", map);
    }

    pageSizeChange(pageSize:number){
        let map = new Map();
        map.set("table", this.resultFieldName);
        map.set("pageSize", pageSize);
        this.$store.commit(this.commitType + "setPageData", map);
    }

    get tableData(){
      let arr = this.queryAction.split("/");
      return this.$store.state[arr[0]][arr[1]][this.resultFieldName];
    }

    styles={
        float:"right",
    }
}
